import { api } from "@/lib/api";

/** Arquivo de fonte da marca (.ttf/.otf/.woff) por papel. O renderizador HTML
 *  usa os BYTES — resolve fontes pagas que não estão no Google Fonts (causa de
 *  "a arte sai tudo Bricolage"). Espelha o tipo do @paperclipai/db. */
export type BrandFontFile = {
  assetId: string;
  family: string;
  role: "headline" | "corpo";
};

export type ProductBrandIdentity = {
  paleta?: string[];
  fontes?: string[];
  /** Fontes enviadas como arquivo (título/corpo) — a arte sai na tipografia real. */
  fontFiles?: BrandFontFile[];
  letteringStyle?: string;
  tomVisual?: string;
  /**
   * Diretrizes visuais livres do PRODUTO. Quando preenchidas, sobrescrevem
   * as diretrizes da marca pra qualquer tarefa que selecionar este produto.
   */
  diretrizes?: string;
};

export type LibraryAsset = {
  attachmentId: string;
  contentPath: string | null;
  byteSize: number | null;
  contentType: string | null;
};

export type PeoplePhoto = LibraryAsset & {
  expertName?: string;
  context?: string;
};

export type CreativeRef = LibraryAsset & {
  category: string;
  notes?: string;
};

export type LogoRef = LibraryAsset & {
  variant?: string;
  notes?: string;
};

export type ProductLibrary = {
  productId: string;
  productName: string;
  brandIdentity: ProductBrandIdentity | null;
  peopleLibrary: PeoplePhoto[];
  creativeLibrary: CreativeRef[];
  logos: LogoRef[];
};

export const productLibraryApi = {
  /** productId é knowledge_bases.id de KB com type='product'. */
  get: (companyId: string, productId: string) =>
    api.get<ProductLibrary>(
      `/companies/${companyId}/products/${productId}/library`,
    ),
  update: (
    companyId: string,
    productId: string,
    payload: {
      brandIdentity?: ProductBrandIdentity;
      peopleLibrary?: Array<{ attachmentId: string; expertName?: string; context?: string }>;
      creativeLibrary?: Array<{ attachmentId: string; category: string; notes?: string }>;
      logos?: Array<{ attachmentId: string; variant?: string; notes?: string }>;
    },
  ) =>
    api.patch<{ ok: true }>(
      `/companies/${companyId}/products/${productId}/library`,
      payload,
    ),
  /** Adiciona um asset existente (ex: arte aprovada) à creative library do
   *  produto. `ref` pode ser asset.id ou issue_attachment.id. */
  addCreative: (
    companyId: string,
    productId: string,
    payload: { ref: string; category?: string; notes?: string },
  ) =>
    api.post<{ ok: true; alreadyInLibrary?: boolean }>(
      `/companies/${companyId}/products/${productId}/library/add-creative`,
      payload,
    ),
};
